<div class="warning-dialog" [ngStyle]="{ 'max-width': maxWidth, 'max-height': maxHeight }">
  <h2 mat-dialog-title>{{ dialogData.title }}</h2>
  <mat-dialog-content>
    <mat-icon>warning</mat-icon>
    <p [innerHtml]="dialogData.message"></p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button color="primary" (click)="ok()">Ok</button>
  </mat-dialog-actions>
</div>
